import notify from 'devextreme/ui/notify';

export default function handleBadRequest(err: any) {
  let errorString = 'Ocurrió un error inesperado.';
  let type = 'error';
  if (err.response) {
    const status = err.response.status;

    if (status === 400) {
      const details = err.response.data?.details;

      if (details && Array.isArray(details)) {
        const fieldsWithErrors = details
          .map((detail: any) => detail.field)
          .join(', ');
        errorString = `Por favor, revise los siguientes campos: ${fieldsWithErrors}`;
        type = 'info';
      } else {
        errorString = 'Ocurrió un error inesperado. Intente nuevamente.';
      }
    } else if (status === 500) {
      const serverErrorMessage = err ? `${err.response.data}` : '';
      errorString = `${serverErrorMessage}`;
    } else if (status === 404) {
      errorString = 'No se encontró el recurso solicitado.';
    } else if (status === 403) {
      errorString = 'No tiene permisos para realizar esta acción.';
    } else {
      errorString =
        err.response.data?.message || 'Ocurrió un error inesperado.';
    }

    notify(
      {
        message: errorString,
        position: {
          my: 'center bottom',
          at: 'center bottom',
        },
      },
      type,
      4000
    );
  } else if (err && !err.response) {
    notify(
      {
        message: err,
        position: {
          my: 'center bottom',
          at: 'center bottom',
        },
      },
      type,
      4000
    );
  }
}
